import React, {PureComponent} from 'react';
import {Design} from 'services/entities/designs';
import './index.scss';

interface DesignPreviewProps {
  design: Design;
}

export default class DesignThumbnail extends PureComponent<DesignPreviewProps> {
  static getDesignPreviewImageURL(design: Design): URL|null {
    let heroGroup = design.screenGroups.find(sg => sg.screenGroup.isDesignHero);
    if(!heroGroup || !heroGroup.thumbnailImageURL) {
      heroGroup = design.screenGroups.find(sg => sg.thumbnailImageURL);
    }
    return heroGroup ? heroGroup.thumbnailImageURL : null;
  }

  render() {
    const design = this.props.design;
    const imageURL = DesignThumbnail.getDesignPreviewImageURL(design);
    return imageURL ? <div className="design-thumbnail"><img className="design-preview" src={imageURL.toString()} alt={design!.name} /></div> : null;
  }
}